export default __webpack_public_path__ + "static/media/create-project.e05bd52f.svg";